module.exports = __webpack_public_path__ + "static/media/environment.e0df35ff.jpg";